import { type ReactNode } from "react";

/**
 * Auth shell — wraps every `/`, `/create-account`, `/forgot-password`,
 * `/forgot-password/reset` route. Same visual contract as the legacy
 * `src/app/(account)/layout.tsx` (the one that the v2 migration
 * accidentally lost): 2-column on lg+ (form + branded image),
 * single column on phones; ROOK logo above the form; auth card
 * capped at max-w-md so long descriptions don't sprawl.
 *
 * The image is `/login-background.webp` from public/, declared as
 * a Tailwind utility (`bg-login-background-image`) in tailwind.config.ts.
 */
export const AccountLayout = ({ children }: { children: ReactNode }) => (
  <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2 bg-background">
    <div className="flex flex-col items-center justify-center px-4 py-8 sm:px-6 lg:px-10">
      <div className="mb-8 flex w-full max-w-md justify-center lg:mb-10 lg:justify-start">
        <img src="/rook-logo.png" alt="Rook" width={140} className="h-auto" />
      </div>
      <div className="w-full max-w-md">{children}</div>
    </div>
    <div className="hidden bg-login-background-image bg-cover bg-center lg:block" />
  </div>
);
